import { type I18nWording, REQUIRED_LOCALES } from '@/services/i18n';

/**
 *
 * @param label An object containing translations
 * @returns true if at least one required translation is missing
 */
export const isMissingTranslation = (label: I18nWording) => {
  return REQUIRED_LOCALES.some((locale) => !label[locale]?.trim());
};
